// A JSON.stringify replacer that keeps an explicit undefined-valued key from vanishing into `{}`, indistinguishable from a cleared filter.
export function nullifyUndefined(_key: string, value: unknown): unknown {
  return value === undefined ? null : value;
}
